
import { isSupportLocalStorage, bake_cookie, read_cookie } from "./cookieHandler";

export const setUserProfile = (userProfileData) => {
    if (isSupportLocalStorage()) {
        localStorage.setItem("profile_data", JSON.stringify(userProfileData));
    } else {
        bake_cookie("profile_data", userProfileData);
    }
}
export const getUserProfile = () => {
    if (isSupportLocalStorage()) {
        if (localStorage.getItem("profile_data")) {
            return JSON.parse(localStorage.getItem("profile_data"));
        } else {
            return {
                customerUserName: '',
                customerName: '',
                profileCDNImage: '../assets/AvatarImage.jpg',
                customerType: 0
            };
        }
    } else {
        if (read_cookie("profile_data")) {
            return read_cookie("profile_data");
        } else {
            return {
                customerUserName: '',
                customerName: '',
                profileCDNImage: '../assets/AvatarImage.jpg',
                customerType: 0
            };
        }
    }
}